import cn from "classnames";
import { Field } from "components/shared/form";
import upperFirst from "lodash/upperFirst";
import React, { useEffect, useState } from "react";
import { applyOrganizationActivityTarget, getOrganizationActivityTarget } from "sources/organizationActivity";

const Goals = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        getOrganizationActivityTarget().then((data) => {
            setData(data);
            setLoading(false);
        });
    }, []);

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        const targetData = {
            ...data,
            averageDowntime:
                data.averageDowntime.split(":").length === 2 ? `${data.averageDowntime}:00` : data.averageDowntime,
        };
        applyOrganizationActivityTarget(targetData).then((res) => {
            setLoading(false);
            if (res) {
                props.back();
            }
        });
    };

    const renderField = (name, fieldProps = {}) => {
        const value = data[name];
        const onFieldChange = ({ value }) => setData({ ...data, [name]: value });
        return <Field inputProps={{ name }} value={value} onChange={onFieldChange} {...fieldProps} />;
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            <h5 className="pb-3">Настройка целей</h5>
            {renderField("countOfCars", { label: "Количество машин" })}
            {renderField("averageMileage", { label: "Средний пробег на ТС" })}
            {renderField("averageBidPrice", { label: "Вал на ТС" })}
            {renderField("outputPerKm", { label: `${upperFirst(props.organization?.currencyData?.name)}/км` })}
            {renderField("outputPerHour", { label: `${upperFirst(props.organization?.currencyData?.name)}/час` })}
            {renderField("emptyMileageRate", { label: "% Порожнего пробега" })}
            {renderField("averageDowntime", { label: "Средний ПРР на ТС", type: "timespan" })}
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
};

export default Goals;
